import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Subject, of as observableOf, Observable } from 'rxjs';
import { map } from "rxjs/operators";

import { environment } from '../environments/environment';

@Injectable()
export class GlobalCfgService {

    public REFRESH_FREEQUENCY = 180 ; //in seconds
    private loggedInUserObj;
    private fullUserObj;
    private LOGIN_TOKEN_PREFIX = 'ttlogintoken108';
    public settings = {};

    public userSource = new Subject<any>();
    userFetchedValue$ = this.userSource.asObservable();
    acl: any;

    constructor(private http: HttpClient) {}
    

    getLoggedInUser() {
        if (typeof(Storage) !== "undefined") {
            var val = localStorage.getItem(this.LOGIN_TOKEN_PREFIX);
            if (val) {
                this.loggedInUserObj = JSON.parse(localStorage.getItem(this.LOGIN_TOKEN_PREFIX));
            }
        } else {
            console.log('Web sorage is not supported on this browser. Login token could not be persisted. You will have to login every time.');
        }
        return this.loggedInUserObj;
    }

    setLoggedInUser(obj, keepMeSignedIn) {
        if (!obj) {
            this.loggedInUserObj = null;
            this.fullUserObj = null;
            if (typeof(Storage) !== "undefined") {
                localStorage.setItem(this.LOGIN_TOKEN_PREFIX, "");
            }
            return;
        }

        this.loggedInUserObj = {
            accessToken: obj.id,
            userId: obj.userId
        };

        if (keepMeSignedIn) {
            if (typeof(Storage) !== "undefined") {
                localStorage.setItem(this.LOGIN_TOKEN_PREFIX, JSON.stringify(this.loggedInUserObj));
            } else {
                console.log('Web sorage is not supported on this browser. Login token cannot be persisted. You will have to login every time.');
            }
        }
    }

    //Input parameter is a user object along with user detail
    setFullUserObj(user) {
        this.fullUserObj = user;
        this.userSource.next(user);
    }

    getFullUserObj() {
        return this.fullUserObj;
    }

    getAccessToken() {
        return this.loggedInUserObj.accessToken;
    }
    
    getUserId() {
        return this.loggedInUserObj.userId;
    }

    setSettings(settings) {
        this.settings = settings;
    }

    getSettingValue(key) {
        return this.settings[key];
    }

    setAcl(acl) {
        this.acl = acl;
    }

    public checkGcpAcl(key): Observable<any> {
        if (this.acl === undefined || this.acl === null) {
            return this.getGcpAcl().pipe(
                map(() => {
                    return this.getAclValueFor(key);
                })
            );
        } else {
          return observableOf(this.getAclValueFor(key)); //take existing data - no need to make a apiService call
        }
    }

    public getGcpAcl() {
        return this.http.get(
            environment.apiurl + 
            "/Billings/subscriptionDetails?access_token=" + this.getAccessToken()
        ).pipe(
            map(res => {
                this.acl = res;
                return this.acl;
            })
        );
	}

    getAclValueFor(key) {
        // debugger
        var ret;
        if (this.acl) {
            ret = this.acl[key];
        }

        return ret;
    }

    getGcp() {
        var selectedGcp = window.localStorage.getItem('selectedGcp');
        selectedGcp = selectedGcp == "null" ? null : selectedGcp;

        if (!selectedGcp) {
            var gcp = window.localStorage.getItem('gcp');
            selectedGcp = gcp == "null" ? null : gcp;
        }

        return selectedGcp;
    }
}